<template lang="pug" src="./templates/ProductSinglePage.pug"></template>

<script>
import { ContentLoader } from 'vue-content-loader';
import matchHeight from 'jquery-match-height';
import BreadcrumbsManager from '../../../mixins/BreadcrumbsManager';
import AddToCompareButton from "../../../components/buttons/shop/AddToCompareButton";
import AddToWishlistButton from '../../../components/buttons/shop/AddToWishlistButton.vue';
import AddToCartButton from '../../../components/buttons/shop/AddToCartButton.vue';
import PageHeader from '../../../components/layouts/PageHeader.vue';
import ProductListItem from '../../../components/product/ProductListItem.vue';
import { RepositoryFactory } from '../../../repositoryFactory';
import notify from '../../../components/notify';
import ProductCategorySpecs from "./ProductCategorySpecs";

import 'swiper/css/swiper.css';
import ConversionManager from '../../../mixins/ConversionManager';

const ProductRepository = RepositoryFactory.get('product');

window.matchHeight = matchHeight;

export default {
  components: {
    AddToCompareButton,
    AddToCartButton,
    AddToWishlistButton,
    ContentLoader,
    PageHeader,
    ProductListItem,
    // Swiper,
    // SwiperSlide,
  },
  directives: {
    // swiper: directive,
  },
  mixins: [BreadcrumbsManager, ConversionManager],
  data() {
    return {
      loading: {
        isFetching: false,
      },
      product: {},
      similar_products: [],
      variants: {},
      selected: {
        variation: null,
        quantity: 1,
      },
      swiperOptions: {
        direction: 'horizontal',
        spaceBetween: 0,
        autoHeight: false,
        loop: false,
        slidesPerView: 1,
        navigation: {
          nextEl: '.product-swiper-button--next',
          prevEl: '.product-swiper-button--prev',
        },
        breakpoints: {
          768: {
            spaceBetween: 10,
          },
        },
      },
      swiperThumbnailOptions: {
        direction: 'vertical',
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    };
  },
  metaInfo() {
    const meta = [{
      name: 'description',
      content: this.product.meta ? this.product.meta.description : this.product.name,
    }, {
      property: 'og:title',
      content: this.product.name,
    }, {
      property: 'og:description',
      content: this.product.meta ? this.product.meta.description : this.product.name,
    }];

    if (typeof this.product.featured_image !== 'undefined') {
      meta.push({
        property: 'og:image',
        content: this.product.featured_image.full_url ? this.product.featured_image.full_url : '',
      });
    }

    return {
      title: this.product.name,
      meta,
    };
  },
  computed: {
    // productSwiper() {
    //   return this.$refs.productSwiper.$swiper;
    // },
    // productThumbnailSwiper() {
    //   return this.$refs.productThumbnailSwiper.$swiper;
    // },
    filteredSpecs() {
      if (this.product.specs) {
        const categorySpecs = ProductCategorySpecs;
        const { class_01 } = this.product;
        // console.log(category, categorySpecs[category]);
        if (typeof categorySpecs[class_01] !== 'undefined') {
          let specs = _.pickBy(this.product.specs, (value, key) => {
            return categorySpecs[class_01].fields.includes(key)
          });
          specs = _.map(specs, (value, key) => {
            return {
              label: categorySpecs[class_01].labels[key] ?? key.charAt(0).toUpperCase() + key.slice(1),
              value
            };
          });
          specs = _.sortBy(specs, [(o) => o.label]);
          return specs;
        }
      }
      return [];
    },
    price() {
      let bulkPrice = false;
      let originalPrice = false;
      _.forEach(this.product.price_ranges, (range, index) => {
        if (index === 0) {
          originalPrice = range.price
        }
        if (this.isQtyInRange(this.selected.quantity, range.minimum_quantity, range.maximum_quantity)) {
          bulkPrice = range.price
        }
      })
      return { bulkPrice, originalPrice };
    }
  },
  watch: {
    $route() {
      this.product = {};
      this.similar_products = [];
      this.selected = {
        variation: null,
        quantity: 1,
      };
      this.getProduct();
    },
  },
  mounted() {
    this.getProduct();

    // this.$nextTick(() => {
    //   const productSwiper = this.$refs.productSwiper.$swiper;
    //   const productThumbnailSwiper = this.$refs.productThumbnailSwiper.$swiper;
    //   productSwiper.controller.control = productThumbnailSwiper;
    //   productThumbnailSwiper.controller.control = productSwiper;
    // });

    this.$watch('variants', async (val) => {
      if (_.size(val, 'length') === _.countBy(this.product.variants, (variant) => variant.variation === 1).true) {
        console.log('all selected');
        const { data } = await ProductRepository.getByVariants(this.$route.params.slug, val);
        this.selected = {
          ...this.selected,
          ...{
            product: this.product,
            variation: data,
          },
        };
      }
    }, { deep: true });
  },
  methods: {
    async getProduct() {
      this.loading = { ...this.loading, ...{ isFetching: true } };
      try {
        const { data } = await ProductRepository.getBySlug(this.$route.params.slug, { lang: this.$store.getters['auth/user'].locale ?? 'th' }).then((resp) => resp.data);
        this.product = { ...this.product, ...data };

        let breadcrumbs = [];
        if (this.product.main_category) breadcrumbs.push({
          name: this.product.main_category.name,
          to: { path: this.product.main_category.permalink }
        });
        if (this.product.category) breadcrumbs.push({
          name: this.product.category.name,
          to: { path: `/shop/${this.product.main_category.slug}/${this.product.category.slug}` }
        });

        if (this.product.related_products && this.product.related_products.length > 0) {
          try {
            const {data} = await ProductRepository.get({
              paginated: false,
              where_in: this.product.related_products
            }).then((resp) => resp.data);
            this.similar_products = data;
          } catch (e) {
            console.error('Fetching similar product error', e);
          }
        }

        this.setBreadcrumbs(breadcrumbs);

        this.selected = {
          ...this.selected,
          ...{
            product: data,
          },
        };

        this.$ga.ecommerce.addImpression({
          id: this.product.item_code,
          name: this.product.name,
        });

        this.$nextTick(() => {
          $('.product-list__item').matchHeight();
        });
      } catch (e) {
        notify.errors(this, e);
      }
      this.loading = { ...this.loading, ...{ isFetching: false } };
    },
    onAdded(cart) {
      console.log('cart', cart);
    },
    onSlideChange() {
      // const activeSlide = this.productSwiper.activeIndex;
      // this.productThumbnailSwiper.slideTo(activeSlide);
    },
    onQtyUpdated(quantity) {
      this.selected = { ...this.selected, ...{ quantity } };
    },
    isQtyInRange(qty, min, max) {
      return qty >= min && qty <= max;
    },
  },
};
</script>
